import moment from 'moment';

import { FILTER_PARAMS } from '../../v2/features/ListingFilters/filters/utils/filterUrlState.ts';
import { buildSessionPairs } from './buildSessionPairs';

const GROUPED_MODES = ['by-week', 'by-location'];

// Hide non-recurring listings whose first (and only) session has already passed.
// Recurring listings are always kept — their future sessions are computed separately.
export const dropEndedSingleEvents = (listings) => {
  const today = moment().startOf('day');

  return (listings || []).filter((listing) => {
    const { isRecurring, firstSession } = listing.attributes?.publicData || {};
    if (!isRecurring || isRecurring === 'no') {
      if (!firstSession) return true;
      return moment(firstSession).isSameOrAfter(today, 'day');
    }
    return true;
  });
};

// The grouped modes card a listing only when it has a session to come, so the filter
// counts must skip the rest. Undefined in the flat mode, where every listing gets a card.
export const getCardListingIds = (listings, listingGroupMode) => {
  if (!GROUPED_MODES.includes(listingGroupMode)) return undefined;

  return [...new Set(buildSessionPairs(listings).map(({ listing }) => listing.id.uuid))];
};

// Applied in the browser (`filterProfileListings`), so `loadData` leaves them out of the query.
export const PROFILE_FILTER_PARAMS = [
  FILTER_PARAMS.location,
  FILTER_PARAMS.category,
  FILTER_PARAMS.days,
];

const withoutFilters = (url) => {
  const params = new URLSearchParams(url.search);
  PROFILE_FILTER_PARAMS.forEach((key) => params.delete(key));
  params.sort();

  return `${url.pathname}?${params}`;
};

// The duck re-exports it for `createRouteConfig`. Without it a filter click re-runs
// `loadData`, whose `setInitialState` blanks the page until the refetch lands.
export const shouldRevalidate = ({ currentUrl, nextUrl, defaultShouldRevalidate }) => {
  const onlyFiltersChanged =
    currentUrl.href !== nextUrl.href && withoutFilters(currentUrl) === withoutFilters(nextUrl);

  return onlyFiltersChanged ? false : defaultShouldRevalidate;
};
